import { AudioAssetRead, VideoAssetRead } from '@generated/types'

export interface MuxAssetRead {
  mux_playback_id: string
  status: AudioAssetRead['status']
}

export function isMuxAssetReady(asset: MuxAssetRead | null | undefined): boolean {
  return asset?.status === 'ready' && !!asset.mux_playback_id
}

export function isVideoAssetReady(video: VideoAssetRead | null | undefined): boolean {
  return isMuxAssetReady(video)
}

// The accept lists and size caps below mirror `MediaAsset.UPLOAD_LIMITS`
// (backend/src/backend/models/MediaAsset.py), which is the source of truth — the mint enforces it
// and 400s on anything outside it. These only exist so the picker rejects a bad file before we mint
// an upload nobody can use, so a change there is a change here too.
const AUDIO_GB_MAX = 1
export const AUDIO_MAX_BYTES = AUDIO_GB_MAX * 1024 ** 3
export const AUDIO_ACCEPT = [
  'audio/aac',
  'audio/flac',
  'audio/mp3',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/opus',
  'audio/wav',
  'audio/wave',
  'audio/webm',
  'audio/x-flac',
  'audio/x-m4a',
  'audio/x-pn-wav',
  'audio/x-wav',
].join(',')

const VIDEO_GB_MAX = 10
export const VIDEO_MAX_BYTES = VIDEO_GB_MAX * 1024 ** 3
export const VIDEO_ACCEPT = [
  'video/mp4',
  'video/mp2t',
  'video/quicktime',
  'video/webm',
  'video/x-m4v',
  'video/x-matroska',
].join(',')
